import router from '../../apps/schedule/router'
export const getters = {
    fetchPending: (state, getters) => getters['listReq/pending'],

    results: (state, getters) => {
        let results = getters['listReq/results'] || [];
        // Handle stars:
        for (const i in results.data) {
            // Store a copy of original value:
            results.data[i].starsOriginal = results.data[i].stars;

            // Convert null and enpty values to 0:
            if (results.data[i].starsOriginal == null || results.data[i].starsOriginal == '') {
                results.data[i].stars = 0;
            }
            // Convert to int to remove decimal and then string for comparision in results screen:
            results.data[i].stars = parseInt(results.data[i].stars).toString();
        }
        // return results.data.sort((a, b) => (a.price > b.price) ? 1 : -1);
        return results;
    },

    onScreenTireSelection:(state) => {
        const productCode = new URLSearchParams(window.location.search).get("product_code");

        function endsWithK(str) { return str.slice(-1).toLowerCase() === 'k'; }

        if(!productCode) {
            console.log( 'No product code found in URL' );
            return null
        }

        let tire = state.listReq.req.results.data.find(el => el.manufacturerproductcode == productCode);
        if (!tire) {
            if ( endsWithK(productCode) ) {
                tire = state.listReq.req.results.data.find(el => el.manufacturerproductcode == productCode.slice(0, -1));
            }
            if (!endsWithK(productCode) ) {
                tire = state.listReq.req.results.data.find(el => el.manufacturerproductcode == productCode + 'K');
            }
        }
        if (!tire ) {
            console.log( 'No tire found with product code: ' + productCode );
            return null
        }
        console.log( "onscreenselection:" );
        console.log( tire );
        return tire;
    },

    onQuotePage: () => {
        const pathArray = window.location.pathname.toLowerCase().split('/');

        return pathArray.includes('tirequote');
    },
};
